import Resource from '@/api/resources/Resource'
/**
    * @deprecated You must use the new service that is located in "configuration/cases/regime/regime-configuration.service.ts"
    */
class RegimeConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/regimes`, filterModel, { params })
        return response.data
    }
    async getRegimesByName(params) {
        const response = await this.axios.get(`/configuration/regimes/search`, { params })
        return response.data
    }
    async patchRegimesBatch(regimes) {
        const response = await this.axios.patch(`/configuration/regimes/batch`, regimes)
        return response.data
    }
    async createRegime(regime) {
        const response = await this.axios.post(`/configuration/regimes`, regime)
        return response.data
    }
    async deleteRegimesBatch(regimes) {
        const data = {
            entityIdentifiers: regimes
        }
        const response = await this.axios.delete(`/configuration/regimes/batch`, { data: data })
        return response.data
    }
}

export default new RegimeConfigurationServices()
